import {
  CLEAR_CONTEXT,
  SET_GROUP_COMPANY_ID,
  SET_GROUP_COMPANY_NAME,
  SET_HAS_MULTIPLE_GROUP_COMPANIES,
  START_PROCESSING,
  STOP_PROCESSING,
  SET_SUBSIDIARY_ID
} from "../constants/actionTypes";

const initialState = {
  hasMultipleGroupCompanies: false,
  groupCompanyId: null,
  groupCompanyName: null,
  subsidiaryId: null,
  processing: false
};

const context = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_CONTEXT:
      return initialState;
    case SET_HAS_MULTIPLE_GROUP_COMPANIES:
      return {
        ...state,
        hasMultipleGroupCompanies: action.hasMultipleGroupCompanies
      };
    case SET_GROUP_COMPANY_ID:
      return {
        ...state,
        groupCompanyId: action.groupCompanyId
      };
    case SET_GROUP_COMPANY_NAME:
        return {
          ...state,
          groupCompanyName: action.groupCompanyName
        };
    case SET_SUBSIDIARY_ID:
      return {
        ...state,
        subsidiaryId: action.subsidiaryId
        };
    case START_PROCESSING:
      return {
        ...state,
        processing: true
      };
    case STOP_PROCESSING:
      return {
        ...state,
        processing: false
      };
    default:
      return state;
  }
};

export default context;
